export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_audit') || '审核补货',
    icon: 'el-icon-s-check',
    menuType: 'audit',
    divided: true,
    allow: 'F',
  },
  {
    text: that.$l('menu_text_submit') || '提交返答',
    icon: 'el-icon-check',
    menuType: 'submit',
    allow: 'S',
  },
]
